import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const mandatedClasses = (classid, usergroupid, Isrepetitive, Frequency) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.GROUP_MANAGEMENT.MANDATE_CLASSES(
      classid,
      usergroupid,
      Isrepetitive,
      Frequency
    )
  );
};

export default mandatedClasses;
